
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import CharField from "@/components/processing_steps/commons/fields/CharField.vue"
import axios from 'axios'
import { IRegulatoryBodyOption } from '@/types/processingSteps'
import SingleSelectField from '../../commons/fields/SingleSelectField.vue'

@Component({
  components: {
    CharField,
    SingleSelectField
  }
})
export default class ForeignOrgaRegulatoryBody extends Vue {
  @Prop() orgaSlug!: string
  @Prop() selectedRegulatoryBodyOptionKey!: string
  @Prop() selectedRegulatoryBodyIdentifier!: string
  @Prop({ default: true }) isEditable!: boolean

  regulatoryBodyData: IRegulatoryBodyOption[] = []
  regulatoryBodyOptions: { value: string, text: string }[] = []
  selectedRegulatoryBodyOption: IRegulatoryBodyOption | null = null
  localSelectedRegulatoryBodyOptionKey = ""
  localSelectedRegulatoryBodyIdentifier = ""

  url = "/api/v4/processing-steps/regulatory-body-options/"

  get identifierLabel (): string {
    if (this.selectedRegulatoryBodyOption) {
      return this.selectedRegulatoryBodyOption.identifier_name
    }
    return this.$gettext("Identifier")
  }

  get identifierPlaceholder (): string {
    if (this.selectedRegulatoryBodyOption) {
      return this.selectedRegulatoryBodyOption.identifier_field_help_text
    }
    return ""
  }

  @Watch('selectedRegulatoryBodyOptionKey')
  onPropChange(newVal: string): void {
    this.localSelectedRegulatoryBodyOptionKey = newVal
  }

  @Watch('localSelectedRegulatoryBodyOptionKey')
  onLocalChange(newVal: string): void {
    this.$emit('update:selectedRegulatoryBodyOptionKey', newVal)
  }

  @Watch('selectedRegulatoryBodyIdentifier')
  onPropChangeIdentifier(newVal: string): void {
    this.localSelectedRegulatoryBodyIdentifier = newVal
  }

  @Watch('localSelectedRegulatoryBodyIdentifier')
  onLocalChangeIdentifier(newVal: string): void {
    this.$emit('update:selectedRegulatoryBodyIdentifier', newVal)
  }

  async mounted(): Promise<void> {
    this.localSelectedRegulatoryBodyOptionKey = this.selectedRegulatoryBodyOptionKey
    this.localSelectedRegulatoryBodyIdentifier = this.selectedRegulatoryBodyIdentifier
    await this.fetchOptions()
    await this.setRegulatoryBodyOptions()
    this.onRegulatoryBodyOptionSelected(this.localSelectedRegulatoryBodyOptionKey)
  }

  async fetchOptions (): Promise<void> {
    const url = this.url + "?organization_slug=" + this.orgaSlug
    await axios.get(url).then(response => {
      this.regulatoryBodyData = response.data
    })
  }

  async setRegulatoryBodyOptions (): Promise<void> {
    this.regulatoryBodyOptions = this.regulatoryBodyData.map((option: IRegulatoryBodyOption) => {
      return {
        value: option.identifier_acronym,
        text: option.regulatory_body_name,
        data: option
      }
    })
  }

  onRegulatoryBodyOptionSelected (selectedOption: string): void {
    this.selectedRegulatoryBodyOption = this.regulatoryBodyData.find((option: IRegulatoryBodyOption) => {
      return option.identifier_acronym === selectedOption
    }) || null
  }
}
